import { render, staticRenderFns } from "./TakeFilter.vue?vue&type=template&id=3a5ad878&scoped=true&"
import script from "./TakeFilter.vue?vue&type=script&lang=babel&"
export * from "./TakeFilter.vue?vue&type=script&lang=babel&"
import style0 from "./TakeFilter.vue?vue&type=style&index=0&id=3a5ad878&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5ad878",
  null
  
)

export default component.exports